import { Image as ShopifyImage } from '@commerce/types/common'
import { SliderChevronLeft, SliderChevronRight } from '@components/icons'
import config from '@config/seo_meta.json'
import { isPinImage } from '@lib/products'
import Image from 'next/image'
import { FC, ReactNode, useState } from 'react'
import Slider from 'react-slick'
interface props {
  images: ShopifyImage[]
}

const CustomArrow: FC<{
  currentSlide?: number | undefined
  slideCount?: number | undefined
  children?: ReactNode
}> = ({ currentSlide, slideCount, children, ...props }) => (
  <span {...props}>{children}</span>
)

const ProductSlickSlider: FC<props> = ({ images }) => {
  const filteredImages = images.filter((i) => !isPinImage(i.url)) // do not show pinterest images
  const [currentSlideNumber, setCurrentSlideNumber] = useState(0)
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: (
      <CustomArrow>
        <SliderChevronRight />
      </CustomArrow>
    ),
    prevArrow: (
      <CustomArrow>
        <SliderChevronLeft />
      </CustomArrow>
    ),
  }
  return (
    <div className="pdp_product_slider aspect-square w-full md:aspect-productImage">
      <Slider
        {...settings}
        beforeChange={(currentSlide: number, nextSlide: number) =>
          setCurrentSlideNumber(nextSlide)
        }
      >
        {filteredImages.map((image, index) => {
          return (
            <div
              className="relative aspect-square w-full md:aspect-productImage"
              key={index}
            >
              <Image
                src={image.url}
                alt={image.altText || config.openGraph.images[0].alt}
                fill
                priority={index == 0 && true}
                className="rounded-sm object-cover md:rounded-none"
                sizes="(max-width: 768px) 90vw, (max-width: 1440px) 33vw, 30vw"
              />
            </div>
          )
        })}
      </Slider>
      <div className="body-2 pt-2 line-clamp-1">
        {filteredImages?.[currentSlideNumber]?.altText}
      </div>
      <style jsx global>{`
        .pdp_product_slider .slick-dots {
          --tw-translate-x: -1.25rem /* 20px */;
          transform: translate(var(--tw-translate-x), var(--tw-translate-y))
            rotate(var(--tw-rotate)) skewX(var(--tw-skew-x))
            skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
            scaleY(var(--tw-scale-y));
        }
        .pdp_product_slider .slick-slider {
          height: 100%;
          width: 100%;
        }
        .pdp_product_slider .slick-list {
          height: 100%;
          width: 100%;
          position: relative;
        }
        .pdp_product_slider .slick-track {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: stretch;
          height: 100%;
          width: 100%;
        }
        .pdp_product_slider .slick-slide {
          height: 100%;
          flex: 1 1 0%;
        }
        .pdp_product_slider .slick-slide > div {
          height: 100%;
          width: 100%;
        }
        .pdp_product_slider .slick-next {
          positioin: absolute;
          right: 8px;
          margin: 0;
        }
        .pdp_product_slider .slick-prev {
          positioin: absolute;
          left: 8px;
          margin: 0;
        }
      `}</style>
    </div>
  )
}

export default ProductSlickSlider
